import { render, staticRenderFns } from "./ReportsTableHeader.vue?vue&type=template&id=2ddb827f&scoped=true&"
import script from "./ReportsTableHeader.vue?vue&type=script&lang=js&"
export * from "./ReportsTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReportsTableHeader.vue?vue&type=style&index=0&id=2ddb827f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddb827f",
  null
  
)

export default component.exports